// removed by extract-text-webpack-plugin
module.exports = {"root":"_1cYKZaAoEMmxjSFmig3TeV"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true,"publicPath":"/"}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-7931856d","scoped":false,"hasInlineConfig":false}!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./src/gotu-vue-common/src/components/comment/Comment.scss
// module id = 992
// module chunks = 1